/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefreshTokenResponse
 */
export interface RefreshTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    accessToken: string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    idToken: string;
    /**
     * 
     * @type {number}
     * @memberof RefreshTokenResponse
     */
    expiresIn: number;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponse
     */
    tokenType: string;
}

/**
 * Check if a given object implements the RefreshTokenResponse interface.
 */
export function instanceOfRefreshTokenResponse(value: object): value is RefreshTokenResponse {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    return true;
}

export function RefreshTokenResponseFromJSON(json: any): RefreshTokenResponse {
    return RefreshTokenResponseFromJSONTyped(json, false);
}

export function RefreshTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefreshTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['accessToken'],
        'refreshToken': json['refreshToken'],
        'idToken': json['idToken'],
        'expiresIn': json['expiresIn'],
        'tokenType': json['tokenType'],
    };
}

export function RefreshTokenResponseToJSON(json: any): RefreshTokenResponse {
    return RefreshTokenResponseToJSONTyped(json, false);
}

export function RefreshTokenResponseToJSONTyped(value?: RefreshTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessToken': value['accessToken'],
        'refreshToken': value['refreshToken'],
        'idToken': value['idToken'],
        'expiresIn': value['expiresIn'],
        'tokenType': value['tokenType'],
    };
}

